export const NODE_ENV: string = process.env.REACT_APP_NODE_ENV as string;
export const GCP_PROJECT: string = process.env.REACT_APP_GCP_PROJECT as string;
export const GCP_REGION: string = process.env.REACT_APP_GCP_REGION as string;
export const GCP_TASKS_QUEUE: string = process.env.REACT_APP_GCP_TASKS_QUEUE as string;
export const GCP_FILE_UPLOAD_BUCKET: string = process.env
  .REACT_APP_GCP_FILE_UPLOAD_BUCKET as string;
export const GCP_RESOURCE_UPLOAD_BUCKET: string = process.env
  .REACT_APP_GCP_RESOURCE_UPLOAD_BUCKET as string;
export const API_ENDPOINT: string = process.env.REACT_APP_API_ENDPOINT as string;
export const GRAPHQL_API_ENDPOINT: string = process.env.REACT_APP_GRAPHQL_ENDPOINT as string;
export const GRAPHQL_API_V2_ENDPOINT: string = process.env.REACT_APP_GRAPHQL_V2_ENDPOINT as string;
export const CLOUD_FUNCTION_URL: string = process.env.REACT_APP_CLOUD_FUNCTION_URL as string;
export const CLOUD_FUNCTION_URL_EUW2: string = process.env
  .REACT_APP_CLOUD_FUNCTION_URL_EUW2 as string;
export const QUANTITATIVE_EXPORT_URL = `${
  process.env.REACT_APP_QUANTITATIVE_EXPORT_URL
}-${process.env.REACT_APP_FIREBASE_GEN2_URL}`;
export const QUALITATIVE_EXPORT_URL = `${
  process.env.REACT_APP_QUALITATIVE_EXPORT_URL
}-${process.env.REACT_APP_FIREBASE_GEN2_URL}`;
export const READINESS_GAUGE_RESPONSES_EXPORT_URL = `${
  process.env.REACT_APP_READINESS_GAUGE_RESPONSES_EXPORT_URL
}-${process.env.REACT_APP_FIREBASE_GEN2_URL}`;

export const METRIC_BI_ID: string = process.env.REACT_APP_METRIC_BI_ID as string;
export const METRIC_DATASET_ID: string = process.env.REACT_APP_METRIC_DATASET_ID as string;
export const METRIC_BI_EMBED_URL: string = process.env.REACT_APP_METRIC_BI_EMBED_URL as string;

export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
  appId: process.env.REACT_APP_FIREBASE_APP_ID as string
};

export const CLOUD_LOGGER_ENDPOINT: string = process.env.REACT_APP_CLOUD_LOGGER_ENDPOINT as string;
export const MFA_TIMEOUT_MS = 5 * 60 * 1000;

export const GA_MEASUREMENT_ID: string = process.env.REACT_APP_GA_MEASUREMENT_ID as string;

export const CUSTOM_DASHBOARD_NAMES_RAW = process.env.REACT_APP_CUSTOM_DASHBOARD_NAMES as string;

// Environments where the Syntiro Honey module may be shown. Enabled on staging
// and on dev (the dev frontend points at the shared honey-api backend). Even with
// the feature flag on, the module stays hidden in any environment not listed here,
// so it can never surface in production until this list is widened.
const SYNTIRO_HONEY_ALLOWED_ENVIRONMENTS = ['staging', 'development'];

export const ENABLE_SYNTIRO_HONEY_MODULE: boolean =
  process.env.REACT_APP_ENABLE_SYNTIRO_HONEY_MODULE === 'true' &&
  SYNTIRO_HONEY_ALLOWED_ENVIRONMENTS.includes(process.env.REACT_APP_NODE_ENV ?? '');
export const SYNTIRO_HONEY_API_ENDPOINT: string = process.env
  .REACT_APP_SYNTIRO_HONEY_API_ENDPOINT as string;

export const SYNTIRO_PBI_COMMENTS_API_ENDPOINT: string = process.env
  .REACT_APP_SYNTIRO_PBI_COMMENTS_API_ENDPOINT as string;

export const SYNTIRO_AGENT_API_ENDPOINT: string = process.env
  .REACT_APP_SYNTIRO_AGENT_API_ENDPOINT as string;

export const ENABLE_ASK_SYNTIRO_CHAT: boolean =
  process.env.REACT_APP_ENABLE_ASK_SYNTIRO_CHAT === 'true' &&
  Boolean(process.env.REACT_APP_SYNTIRO_AGENT_API_ENDPOINT);
